import React, { FC, useCallback } from 'react'
import { db } from 'firebase/index'
import { BasicCard } from 'components/Card/index'
import { TextButton } from 'components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getRole, getStoreRef } from 'reducks/auth/selectors'
import { Role } from 'lib/role'
import { push } from 'connected-react-router'
import { BusinessHourAccordion } from 'components/Accordion'
import { switchStoreRef } from 'reducks/auth/operations'

type Props = {
  isAdmin?: boolean
  storeId?: string
}

const BusinessHourCard: FC<Props> = (props) => {
  const { isAdmin, storeId } = props
  const dispatch = useDispatch()

  const role = useSelector((state: State) => getRole(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const roleManager = new Role(role, storeRef)

  const goToBusinessHourPage = useCallback(() => {
    if (isAdmin && storeId) {
      dispatch(
        switchStoreRef(
          db.collection('stores').doc(storeId),
          undefined,
          undefined,
          false,
          '/account/settings/business_hour'
        )
      )
    } else {
      dispatch(push('/account/settings/business_hour'))
    }
  }, [dispatch, isAdmin, storeId])

  return (
    <BasicCard
      buttonComponent={
        roleManager.hasEnoughRole(9) || isAdmin ? (
          <TextButton label={'営業時間・定休日を設定'} onClick={goToBusinessHourPage} />
        ) : (
          <></>
        )
      }
      title={'現在の設定'}
    >
      <BusinessHourAccordion />
    </BasicCard>
  )
}

export default BusinessHourCard
